import React from 'react';
import findIndex from 'lodash.findindex';
import cx from 'classnames';
import $ from 'jquery'; 

import { Content as NavigationContent } from './Header/Navigation/Content.js';

/*
  Usage: wrap page content in <PageTransitioner>...</PageTransitioner>
  Add [data-page-transition-to="<PAGE_NAME>"] to any page element that you want to trigger a page transition
*/

export default class PageTransitioner extends React.Component {
  constructor(props) {
    super(props);

    // NOTE - Update these if CSS timings are changed
    this.HEADER_TRANSITION_TIMEOUT = 450;
    this.PAGE_TRANSITION_TIMEOUT = 450;

    this.state = {
      direction: 'right',
      doHeaderTransition: false,
      isTransitioningIn: true,
      isTransitioningOut: false,
      transitioningTo: undefined,
      isHidden: false
    };

    this.handleClickTransitionPage = this.handleClickTransitionPage.bind(this);
    this.doHeaderTransition = this.doHeaderTransition.bind(this);
    this.doPageTransition = this.doPageTransition.bind(this);
  }

  componentDidMount() {
    this.addEventListeners();
    this.setLoaded();
  }

  addEventListeners() {
    const anchors = this.refs.el.querySelectorAll('[data-page-transition-to]');
    if (anchors) $(anchors).on('click', this.handleClickTransitionPage);
  }

  setLoaded() {
    setTimeout(() => {
      this.setState({
        isTransitioningIn: false,
      });
    }, 0);

    setTimeout(() => {
      this.setState({
        isHidden: true,
      });
    }, this.PAGE_TRANSITION_TIMEOUT);
  }

  handleClickTransitionPage(e) {
    // Inline attributes are always strings
    const shouldSkip = $(e.currentTarget).attr('data-skip-transition') === 'true';

    if (shouldSkip) {
      // Allow default event to occur
      return;
    }

    e.preventDefault();

    const slug = e.currentTarget.dataset.pageTransitionTo;
    const nextPageIndex = findIndex(NavigationContent.menu_items, { slug });

    if (nextPageIndex === -1) {
      throw new Error('Unable to resolve page transition target.');
    }

    const nextPage = NavigationContent.menu_items[nextPageIndex];
    const currentPageIndex = findIndex(NavigationContent.menu_items, { slug: this.props.page });
    const direction = nextPageIndex > currentPageIndex ? 'right' : 'left';

    this.setState({
      direction
    });

    this.doHeaderTransition(this.doPageTransition, nextPage, direction);
  }

  doHeaderTransition(callback, page, direction) {
    this.setState({
      doHeaderTransition: true,
      isTransitioningOut: true,
      isHidden: false
    }, () => {
      setTimeout(() => {
        callback(page);
      }, this.HEADER_TRANSITION_TIMEOUT);
    });
  }

  doPageTransition(page) {
    this.setState({
      isTransitioningOut: true,
      transitioningTo: page.slug,
      isHidden: false
    }, () => {
      setTimeout(() => {
        window.location.href = page.href;
      }, this.PAGE_TRANSITION_TIMEOUT);
    });
  }

  render() {
    const { isTransitioningOut, isTransitioningIn, transitioningTo, doHeaderTransition, direction, isHidden } = this.state;

    const directionClass = `PageTransitioner--direction-${direction}`;
    const transitioningToClass = (transitioningTo) ? `PageTransitioner--transitioning-to-${transitioningTo}` : '';

    const className = cx(
      `PageTransitioner ${directionClass} ${transitioningToClass}`,
      {
        'PageTransitioner--is-transitioning-in': isTransitioningIn,
        'PageTransitioner--is-transitioning-out': isTransitioningOut,
        'PageTransitioner--is-header-transition': doHeaderTransition,
        'PageTransitioner--is-hidden': isHidden,
      }
    );

    return (
      <div ref="el" className={className}>
        {this.props.children}
      </div>
    );
  }

};
